/**
 * @file 调试控制
 * @author mengchen <mengchen@babytree-inc.com>
 */

import { loadScript } from './index';
import { processEnv } from './config';
import bbtNative from '@bbtfe/native';
import queryString from 'utils/query-string';
import { history } from 'core/history';

export function openDebug() {
  // 孕育app内，开发，测试，预上线开启模拟，或者如果页面参数带debug=1则开启模拟（线上查问题留一手）
  if (
      processEnv.hostEnv != 'online' ||
      (processEnv.hostEnv == 'online' &&
          window.location.search.indexOf('debug=1') > -1)
  ) {
    loadScript('//h5cdn.babytreeimg.com/h5_fe_lib/libs/vconsole.min.js').then(
        () => {
          if (window.VConsole) {
            new window.VConsole();
          }
        }
    );
  }
}

let isSimulator = false;

export function openAppSimulator() {
  if (processEnv.hostEnv !== 'local') return;
  if (bbtNative.isApp()) {
    return;
  }
  isSimulator = true;
  const ua = navigator.userAgent;
  Object.defineProperty(navigator, 'userAgent', {
    value: `pregnancy ${ua}`,
    writable: false
  });
  // 孕育app外，开发，测试，预上线开启模拟
  // window.USER_INFO = {
  //   appname: 'pregnancy',
  //   certification: '0',
  //   clientRole: '2',
  //   currentBabyId: '66380112',
  //   encUserId: 'u142791107054',
  //   euid: 'a6de943210d036bd0d60ee4a7f67a0e0',
  //   isCheckToBind: '1',
  //   nickname: '我是真的喜欢你这样的话丰',
  //   phoneNum: '18810087054',
  //   loginString: 'u142791107054_c1bb0d2c60fa3fd527e1c089ff641452_1730430896_BFC5DE18-C4BA-49FC-8FEB-46E42A471B1A',
  //   current_baby_id: '66380115',
  //   birthday: '2018-12-11'
  // };
  bbtNative.ready = function (callback) {
    bbtNative.userinfo = window.USER_INFO;
    callback(bbtNative);
  };
  // http://21.babytree-test.com/api/mobile_baby/set_baby_info?build_serial=6163c0c8&client_type=android&current_baby_id=62960419&login_string=u63276526931_448606a70486380fbc25ebd3bc586a74_1600495522&
  // local_ts=1600845839&app_id=pregnancy&longitude=116.462595&userencodeid=u63276526931&source_channel=babytree&babytree_net_type=1&version=8.35.0&bpreg_brithday=2018-12-11
  // &device_model=vivo+NEX+A&latitude=39.927829&client_baby_status=3&ali_abtest_sample_id=100014&secret=dbb2c09fc7a8e5805259de925db9b0ef&mac=20:f7:7c:87:56:13&client_role=2
  // &babytree_client_type=android&download_ts=1600494564&bbtid=c8edddd645f20a8e&operate_type=get_baby_list&ali_abtest_type=165&device_brand=vivo&imei=869111045225252&android_id=c8edddd645f20a8e
  bbtNative.encryptApi = function (query = {}, callback) {
    query.skip = 1;
    callback &&
    callback(
        queryString
            .stringifyUrl({
              url: '',
              query
            })
            .slice(1)
    );
  };
  bbtNative.openWebview = function (title, url) {
    if (url.indexOf(location.origin) > -1) {
      history.push(url.replace(location.origin, ''));
    } else {
      window.location.href = url;
    }
  };
  bbtNative.closeWebview = function () {
    history.goBack();
  };
}

openAppSimulator();
if (!isSimulator) {
  openDebug();
}
